<template>
  <p class="zord-details">
    <strong class="zord-details-description">{{ description }}</strong>
    <span class="zord-details-value">{{ value }}</span>
  </p>
</template>

<script>
export default {
  name: 'ZordDetails',
  props: {
    description: {
      type: String,
      default: '',
      required: true
    },
    value: {
      type: String,
      default: '',
      required: true
    },
  }
}
</script>

<style lang="scss" scoped>
  .zord-details {
    display: flex;
    gap: var(--spacing-xs);
    margin-bottom: 0;
    line-height: calc(var(--text-size) + var(--spacing));
    font-size: var(--text-size);
    color: var(--text-color);

    &-description {
      text-transform: uppercase;
    }
  }
</style>
